import { render, staticRenderFns } from "./origin-table.vue?vue&type=template&id=760be3fc&"
import script from "./origin-table.vue?vue&type=script&lang=js&"
export * from "./origin-table.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports